<template>
  <div v-if="!!value" class="link-container">
    <router-link :to="routerLinkTo" style="font-size: 12px;">
      {{ label }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    entity: {
      type: String
    },
    label: {
      type: String
    }
  },
  computed: {
    routerLinkTo() {
      return this.value ? { name: 'Edit' + this.entity, params: { id: this.value } } : '';
    }
  }
};
</script>
